import { render } from "./ScheduleReceiptDetails.vue?vue&type=template&id=dda5548a&scoped=true"
import script from "./ScheduleReceiptDetails.vue?vue&type=script&lang=js"
export * from "./ScheduleReceiptDetails.vue?vue&type=script&lang=js"

import "./ScheduleReceiptDetails.vue?vue&type=style&index=0&id=dda5548a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dda5548a"]])

export default __exports__